<template>
    <section>
        <v-btn text class="px-0 green--text back" @click="$router.go(-1)" absolute v-if="$vuetify.breakpoint.mdAndDown">
            <svg v-svg="'icon-back'" size="11" fill="currentColor" class="mr-1"></svg>
            <span>{{$t('global.back')}}</span>
        </v-btn>

        <h1 class="mt-5 mb-3 text-center">{{$t('quizzes.header')}}</h1>

        <ValidationObserver ref="form" v-slot="{ handleSubmit }">
            <v-form @submit.prevent="handleSubmit(rateQuiz)" class="d-flex flex-column">
                <v-data-table :headers="headers"
                              :items="quiz_results"
                              hide-default-footer
                              class="elevation-1 mt-10 mb-6"
                              mobile-breakpoint="0"
                >
                    <template v-slot:item.id="props">
                        {{props.index+1}}
                    </template>

                    <template v-slot:item.score="props">
                        <ValidationProvider :name="$t('quizzes.score')" rules="required" v-slot="{ errors }" v-if="props.item.rated_score == null">
                            <v-select :items="scores_for_rate[props.index]"
                                      :label="$t('quizzes.score')"
                                      v-model="props.item.rated"
                            >
                                <template v-slot:append>
                                    <svg v-svg="'icon-select'" size="16"></svg>
                                </template>
                            </v-select>
                            <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                        </ValidationProvider>
                        <span v-else>{{props.item.rated_score}}</span>
                    </template>
                </v-data-table>

                <v-btn class="green white--text align-self-end"
                       width="90" height="30"
                       type="submit"
                       :loading="loadingRequest"
                       v-if="quiz_results[0] && quiz_results[0].rated_score == null"
                >{{$t('quizzes.rate')}}</v-btn>
            </v-form>
        </ValidationObserver>
    </section>
</template>

<script>
    export default {
        data(){
            return {
                loadingRequest: false,
                headers: [
                    {text: '#ID', sortable: false, value: 'id'},
                    {text: this.$t('quizzes.questions'), sortable: false, value: 'title'},
                    {text: this.$t('quizzes.answer'), sortable: false, value: 'answers', width: '30%'},
                    {text: this.$t('quizzes.score'), sortable: false, value: 'score', width: '10%'}
                ],
                quiz_results: [],
                scores_for_rate: [],
            }
        },

        mounted(){
            this.getData();
        },

        methods: {
            getData(){
                this.loadingRequest = true;
                this.$api('results').getQuizResults(this.$route.query.quiz_id).then(res => {
                    this.quiz_results = res.data.quiz_results;
                    this.loadingRequest = false;
                    this.getScoreArr();
                });
            },

            getScoreArr(){
                this.quiz_results.forEach((item, index) => {
                    let scores_for_rate = [];
                    for (let i=0; i<=item.score; i+=0.5){
                        scores_for_rate.push(i);
                    }
                    this.scores_for_rate[index] = scores_for_rate;
                });
            },

            rateQuiz(){
                let rated_scores = [];
                this.quiz_results.forEach(item => {
                    rated_scores.push({question_id: item.question_id, rated_score: item.rated});
                });
                this.$api('results').rateQuiz({rated_scores:  rated_scores}, this.$route.query.quiz_id)
                    .then(() => {
                        this.$store.dispatch('alert', {type: 1, message: this.$t('quizzes.success_rated')});
                        this.getData();
                    });
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../scss/pages/tablePages";
    @media (min-width: 1260px){
        .v-data-table::v-deep td{
            white-space: normal;
        }
    }
</style>